"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeStampToShortReadableDate = exports.IsValidDate = exports.DateToShortReadableDate = exports.DateToShortIsoString = exports.DateToDateAndTimeFormat = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
// Returns format 2022-09-06 for the 6th of September 2022
const DateToShortIsoString = date => {
  if (!date) {
    return date;
  }
  const newDate = new Date(date);
  if (Number.isNaN(newDate.getDate())) {
    /* eslint-disable-next-line no-console */
    console.error('Invalid date format');
    return newDate;
  }

  // TODO: Get the timezone as a parameter for internationalization.
  const [day, month, year] = new Intl.DateTimeFormat('en-AU', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(newDate).split('/');
  const dateAsString = "".concat(year, "-").concat(month, "-").concat(day);
  return dateAsString;
};

// https://stackoverflow.com/questions/7445328/check-if-a-string-is-a-date-value
exports.DateToShortIsoString = DateToShortIsoString;
const IsValidDate = (dateString, minDate) => {
  if (!dateString) {
    return false;
  }
  const newDate = new Date(dateString);
  const isValidMinDate = !minDate || newDate.getTime() >= new Date(minDate).getTime();
  const isValidDate = newDate !== 'Invalid Date' && !Number.isNaN(newDate.getDate()) && isValidMinDate;
  return isValidDate;
};

// Returns format 06 Sep 2022
exports.IsValidDate = IsValidDate;
const DateToShortReadableDate = date => {
  const newDate = new Date(date);
  if (Number.isNaN(newDate.getDate())) {
    /* eslint-disable-next-line no-console */
    console.error('Invalid date format');
    return null;
  }

  // TODO: Get the timezone as a parameter for internationalization.
  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  };
  return new Intl.DateTimeFormat('en-GB', options).format(date);
};

// Returns format 13/03/2025 12:51 PM
exports.DateToShortReadableDate = DateToShortReadableDate;
const DateToDateAndTimeFormat = exports.DateToDateAndTimeFormat = function DateToDateAndTimeFormat(date) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-AU';
  const newDate = new Date(date);
  if (Number.isNaN(newDate.getTime())) {
    return null;
  }
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };
  const formattedDate = new Intl.DateTimeFormat(locale, options).format(newDate); // Returns 13/03/2025, 12:51 PM
  const [datePart, timePart] = formattedDate.split(', ');
  return "".concat(datePart, " ").concat(timePart);
};
const TimeStampToShortReadableDate = timestamp => {
  if (new Date(timestamp) && !Number.isNaN(new Date(timestamp).getDate())) {
    return DateToShortReadableDate(new Date(timestamp));
  }
  return timestamp;
};
exports.TimeStampToShortReadableDate = TimeStampToShortReadableDate;